module.exports = __webpack_public_path__ + "img/exhibitimgzh.fbf91bd0.png";